<template>
  <div class="view-fees-paid">
    <div>

      <v-row class="mx-3">
        <v-col class="text-left">
          <v-checkbox v-model="printTwoCopies" label="Print 2 Copies"></v-checkbox>
        </v-col>
        <v-col class="text-right">
          <v-btn elevation="1" color="white" v-if="!isLoading && receipt != null && receipt.is_latest && currentUser.privileges.canDeleteStudentFeeReceipts" @click="showDeleteConfirmation = true" class="mr-2">Delete</v-btn>
          <v-btn elevation="1" color="white" v-if="!isLoading" @click="printPdf" class="mr-2">Print</v-btn>
          <v-tooltip bottom :disabled="!disableEmail">
            <template v-slot:activator="{ on, attrs }">
            <span v-bind="attrs" v-on="on">
              <v-btn elevation="1" color="white" v-if="!isLoading" :disabled="disableEmail" @click="emailReceipt">SEND EMAIL</v-btn>
              <v-progress-circular v-else indeterminate color="primary"></v-progress-circular>
            </span>            
            </template>
            <span>Student's email not set</span>
          </v-tooltip>          
        </v-col>
      </v-row>

      <FeeReceiptTable id="fee-receipt-table" :receipt="receipt" :copyName="`${printTwoCopies || receipt.settings.office_copy_first ? 'OFFICE COPY' : ''}`" />
      <FeeReceiptTable v-if="printTwoCopies" id="fee-receipt-table" :receipt="receipt" :copyName="`${printTwoCopies ? 'PARENT COPY' : ''}`" />

      <v-card class="mx-4 my-4 px-4 py-4">
        <h2 class="text-left mb-2">Payment Details</h2>
        <v-divider class="mb-6"></v-divider>
        <v-row>
          <v-col cols="12" md="6" class="py-0">
            <p class="text-left">
              Payment Mode :
              <b>{{ receipt.mode}}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <p class="text-left">
              Payment Collection Date :
              <b>{{ moment(receipt.created).format('DD MMM YYYY') }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0">
            <p class="text-left">
              Collected By :
              <b>{{ receipt.creator.full_name }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0"  v-if="receipt.mode_details.cheque_number">
            <p class="text-left">
             Cheque Number :
              <b>{{ receipt.mode_details.cheque_number }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.cheque_issued_to">
            <p class="text-left">
             Cheque Issued To :
              <b>{{ receipt.mode_details.cheque_issued_to }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.dd_number">
            <p class="text-left">
             DD Number :
              <b>{{ receipt.mode_details.dd_number }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.dd_issued_to">
            <p class="text-left">
             DD Issued To :
              <b>{{ receipt.mode_details.dd_issued_to }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.cheque_date">            
            <p class="text-left">
              Cheque Date :
              <b>{{ moment(receipt.mode_details.cheque_date).format('DD MMM YYYY') }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.dd_date">
            <p class="text-left">
              DD Date :
              <b>{{ moment(receipt.mode_details.dd_date).format('DD MMM YYYY') }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.utr_number">
            <p class="text-left">
             UTR Number :
              <b>{{ receipt.mode_details.utr_number }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.transaction_id">
            <p class="text-left">
             Transaction ID :
              <b>{{ receipt.mode_details.transaction_id }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.bank_name">
            <p class="text-left">
              Bank Name :
              <b>{{ receipt.mode_details.bank_name }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.mode_details.bank_branch">
            <p class="text-left">
              Bank Branch :
              <b>{{ receipt.mode_details.bank_branch }}</b>
            </p>
          </v-col>
          <v-col cols="12" md="6" class="py-0" v-if="receipt.finance_account">
            <p class="text-left">
              Finance Account :
              <router-link :to="{ name: 'AllTransactions', query: { filter__account: receipt.finance_account.id }, }">
                <b>{{ receipt.finance_account.name }}</b>
              </router-link>
            </p>
          </v-col>
        </v-row>
      </v-card>
    </div>
    <v-snackbar v-model="snackbar.visible" :color="snackbar.color" multiline>
      {{ snackbar.text }}
      <template v-slot:action="{ attrs }">
        <v-btn dark text v-bind="attrs" @click="snackbar.visible = false"
          >Close</v-btn
        >
      </template>
    </v-snackbar>
     <DeleteConfirmationDialog
            title="Are you sure you want to delete this recently created Fee Receipt?"
            description="This action cannot be undone."
            :visible="showDeleteConfirmation"
            @deleteObject="deleteReceipt"
        />
  </div>
  
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import endpoints from "@api/repository";
import api from "@api/index";
import moment from "moment";
import FeeReceiptTable from "@components/fees/FeeReceiptTable";
import DeleteConfirmationDialog from "@components/widgets/dialogs/DeleteConfirmationDialog";
// import html2canvas from "html2canvas";
// import jsPDF from "jspdf";

export default {
  name: "ViewFeesPaid",
  data() {
    return {
      receipt: null,
      printTwoCopies: false,
      showDeleteConfirmation: false,
      moment: moment,
      snackbar: {
        visible: false,
        text: "",
        color: 'green',
      },
      disableEmail: true,
    };
  },
  components: {
    FeeReceiptTable,
    DeleteConfirmationDialog
  },
  computed: {
    ...mapGetters([
      "currentUser",
      "currentInstitution",
      "accessToken",
      "isLoading",
    ]),
    essentials() {
      return {
        accessToken: this.accessToken,
        setLoading: this.setLoading,
        handleErrorsFunction: this.handleApiErrors,
      };
    },
  },
  methods: {
    ...mapActions(["setLoading"]),
    async getReceiptData() {
      this.receipt = await api.call(
        this.essentials,
        endpoints.getFeeReceiptDetails + this.$route.params.rid + "/"
      );
      if(this.receipt.fee_account.student.email){
        this.disableEmail=false;
      }
    },

    async emailReceipt(){
        var response = await api.call(
          this.essentials,
          endpoints.getFeeReceiptDetails + "email/" + this.$route.params.rid + "/"
      );
      if(response && response == 200){
        this.snackbar.text = 'Email has been sent successfully'
        this.snackbar.color = 'success'
        this.snackbar.visible = true
      }
      else{
        this.snackbar.text = 'User e-mail not found'
        this.snackbar.color = 'error'
        this.snackbar.visible = true
      }
    },

    async deleteReceipt(confirm) {
        this.showDeleteConfirmation = false;
        var url = endpoints.undoFeeReceipt;
        if (confirm) {
            var response;
            response = await api.handleApi({
                apiEssentials: this.essentials,
                url: url,
                method: api.Methods.DELETE,
                responseVar: response,
            });
            if (response) {
                this.$router.push({ name: "StudentFeeDetails", params: {sid: this.receipt.fee_account.student.id}});
            }
        }
    },


    async printPdf() {
      var windowOptions =
        "directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=no,resizable=no,width=1024,height=768";
      window.open(
        "/fees/records/students/receipt/print/" +
          // this.$route.params.sid +
          // "/" +
          this.$route.params.rid +
          "/" +
          (this.printTwoCopies ? "2" : "1"),
        "Print Receipt",
        windowOptions
      );
    },

    // async getDataUri(url, cb) {
    //   var image = new Image();
    //   image.setAttribute("crossOrigin", "anonymous"); //getting images from external domain

    //   image.onload = function () {
    //     var canvas = document.createElement("canvas");
    //     canvas.width = this.naturalWidth;
    //     canvas.height = this.naturalHeight;

    //     //next three lines for white background in case png has a transparent background
    //     var ctx = canvas.getContext("2d");
    //     ctx.fillStyle = "#fff"; /// set white fill style
    //     ctx.fillRect(0, 0, canvas.width, canvas.height);

    //     canvas.getContext("2d").drawImage(this, 0, 0);

    //     cb(canvas.toDataURL("image/jpeg"));
    //   };

    //   image.src = url;
    // },

    // async printPdf() {
    //   var self = this;
    //   this.setLoading(true);
    //   html2canvas(document.getElementById("fee-receipt-table"), {
    //     scale: 1.5,
    //   }).then(async function (canvas) {
    //     let imgData = canvas.toDataURL("image/png");

    //     let imgWidth = 190,
    //       pageHeight = 275,
    //       imgHeight = (canvas.height * imgWidth) / canvas.width,
    //       heightLeft = imgHeight,
    //       doc = new jsPDF("p", "mm"),
    //       position = 10;

    //     doc.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    //     heightLeft -= pageHeight;

    //     while (heightLeft >= 0) {
    //       position = heightLeft - imgHeight;
    //       doc.addPage();
    //       doc.addImage(imgData, "PNG", 10, position, imgWidth, imgHeight);
    //       heightLeft -= pageHeight;
    //     }

    //     // appending logo
    //     var logo = null;

    //     self.getDataUri(self.currentInstitution.logo, function (dataUri) {
    //       logo = dataUri;
    //       doc.addImage(logo, "PNG", 12, 12, 12, 12);
    //       doc.save("receipt.pdf");
    //       self.setLoading(false);
    //     });
    //   });
    // },
  },
  created() {
    this.getReceiptData();
  },
};
</script>